module.exports = {"account":"เข้าสู่ระบบ","login":"เข้าสู่ระบบ","o365":"เข้าสู่ระบบด้วย O365","google":"เข้าสู่ระบบด้วย Google","exchange":"เข้าสู่ระบบด้วย Exchange","local":"เข้าสู่ระบบด้วย Local","remember":"จำฉันไว้ในระบบ","email":"อีเมล","password":"รหัสผ่าน","error":"กรุณากรอกข้อมูล","emailerror":"กรุณากรอกอีเมล","OR":"หรือ"}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/login/TH.json
// module id = 1335
// module chunks = 120